import { adminAPI } from './api';

export const userService = {
  // Get all users with filtering
  getUsers: async (type = 'all') => {
    try {
      console.log('🔍 Fetching users with type:', type);
      
      // Now uses the corrected endpoint: /api/admin/users?type=...
      const response = await adminAPI.getUsers(type);
      
      console.log('✅ Users API response:', {
        status: response.status,
        url: response.config?.url,
        dataLength: response.data?.data?.length
      });
      
      console.log('📊 User statistics:', response.data?.statistics);
      
      // Handle the response format
      if (response.data && response.data.success === true) {
        return {
          success: true,
          data: response.data.data || [],
          statistics: response.data.statistics || {}
        };
      } else {
        console.log('⚠️ Unexpected data format:', response.data);
        return {
          success: true,
          data: [],
          statistics: {}
        };
      }
      
    } catch (error) {
      console.error('❌ Failed to fetch users:', {
        message: error.message,
        status: error.response?.status,
        url: error.config?.url,
        data: error.response?.data
      });
      
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to load users'
      };
    }
  },

  // Ban user - NOW USES CORRECT ENDPOINT
  banUser: async (userId, reason) => {
    try {
      console.log(`🚨 Attempting to ban user ${userId} with reason:`, reason);
      
      // Now uses the corrected endpoint: /api/admin/users/{userId}/ban
      const response = await adminAPI.banUser(userId, reason || "Violation of platform terms");
      
      console.log('✅ Ban response:', {
        status: response.status,
        data: response.data,
        url: response.config?.url
      });
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('❌ Failed to ban user:', {
        message: error.message,
        status: error.response?.status,
        url: error.config?.url,
        data: error.response?.data
      });
      
      // Provide helpful error messages
      let errorMessage = 'Failed to ban user';
      if (error.response?.status === 404) {
        errorMessage = 'Ban endpoint not found. Please check backend routes.';
      } else if (error.response?.status === 403) {
        errorMessage = 'You do not have permission to ban users.';
      } else if (error.response?.status === 401) {
        errorMessage = 'Authentication required. Please log in again.';
      }
      
      return {
        success: false,
        message: error.response?.data?.message || errorMessage
      };
    }
  },

  // Unban user - NOW USES CORRECT ENDPOINT
  unbanUser: async (userId) => {
    try {
      console.log(`🔓 Attempting to unban user ${userId}`);
      
      // Now uses the corrected endpoint: /api/admin/users/{userId}/unban
      const response = await adminAPI.unbanUser(userId);
      
      console.log('✅ Unban response:', {
        status: response.status,
        data: response.data,
        url: response.config?.url
      });
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('❌ Failed to unban user:', {
        message: error.message,
        status: error.response?.status,
        url: error.config?.url,
        data: error.response?.data
      });
      
      let errorMessage = 'Failed to unban user';
      if (error.response?.status === 404) {
        errorMessage = 'Unban endpoint not found. Please check backend routes.';
      }
      
      return {
        success: false,
        message: error.response?.data?.message || errorMessage
      };
    }
  },

  // NEW: Send email to user
  sendEmailToUser: async (userId, emailData) => {
    try {
      console.log(`✉️ Sending email to user ${userId}:`, emailData);
      
      const response = await adminAPI.sendEmailToUser(userId, {
        subject: emailData.subject,
        message: emailData.message
      });
      
      console.log('✅ Email sent:', response.data);
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('❌ Failed to send email:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      });
      
      // Provide helpful error messages
      let errorMessage = 'Failed to send email';
      if (error.response?.status === 404) {
        errorMessage = 'Email endpoint not found. Please check backend routes.';
      } else if (error.response?.status === 403) {
        errorMessage = 'You do not have permission to send emails.';
      } else if (error.response?.status === 401) {
        errorMessage = 'Authentication required. Please log in again.';
      }
      
      return {
        success: false,
        message: error.response?.data?.message || errorMessage
      };
    }
  },

  // Get user by ID - ALREADY CORRECT
  getUserById: async (userId) => {
    try {
      console.log(`👤 Fetching user details for ID: ${userId}`);
      
      const response = await adminAPI.getUserById(userId);
      
      console.log('✅ User details response:', {
        status: response.status,
        url: response.config?.url
      });
      
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('❌ Failed to fetch user:', {
        message: error.message,
        status: error.response?.status,
        url: error.config?.url,
        data: error.response?.data
      });
      
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to load user details'
      };
    }
  },
  
  // Quick test function to verify endpoints
  testEndpoints: async () => {
    console.log('🧪 Testing user management endpoints...');
    
    const tests = [
      { name: 'Get Users', func: () => adminAPI.getUsers('all') },
      { name: 'Ban User', func: () => adminAPI.banUser(1, 'test') },
      { name: 'Unban User', func: () => adminAPI.unbanUser(1) },
      { name: 'Send Email', func: () => adminAPI.sendEmailToUser(1, { subject: 'Test', message: 'Test message' }) }
    ];
    
    const results = {};
    
    for (const test of tests) {
      try {
        const response = await test.func();
        results[test.name] = {
          success: response.status >= 200 && response.status < 300,
          status: response.status,
          data: response.data
        };
      } catch (error) {
        results[test.name] = {
          success: false,
          status: error.response?.status,
          error: error.message,
          url: error.config?.url
        };
      }
    }
    
    console.log('📊 Test Results:', results);
    return results;
  }
};